import { useContext } from "react";
import { LoanDashboardContext } from "./LoanDashboard.context";

export function useLoanDashboardContext() {
  const context = useContext(LoanDashboardContext)

  if (!context) {
    throw new Error("useLoanDashboardContext deve ser utilizado apenas dentro de LoanDashboardProvider")
  }

  return context
}